module.exports = __webpack_public_path__ + "media/images/full-page-loading-6012080a81216a2e11914f60f21a5bfe.gif";